var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"main1",staticStyle:{"gap":"10px"}},[_c('FilialeOverview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }